import Render from '@Views/root/parameters/google-review.html'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { IConfiguration, IBreadcrumbItem } from '@Store/types'
import { breadcrumb, user } from '@Store/modules'
import {SmsHelper} from "@Helpers/sms";

@Render
@Component({})
export class GoogleReview extends Vue {

	private googleReviewTextWarning: boolean = false
	private static maxLength: number = 160

	@Prop() configuration: IConfiguration

	get isMainUser(): boolean {
		return user.isMainUser
	}

	get googleReviewError(): boolean {
		return this.googleReviewTextWarning
	}

	get googleReviewErrorMessage(): string {
		if (this.googleReviewTextWarning)
			return this.$i18n
				.t('vm.root.parameters.google-review.error.too-long')
				.toString()

		return ''
	}

	get reminderTextLength(): string {
		let length: number = this.computeGoogleReviewTextLength()
		return this.$i18n.tc('vm.root.parameters.google-review.remaining-characters', length).toString()
	}

	mounted() {
		this.$emit('navigate', 'google-review')
		breadcrumb.updateLinked(false)
		this.initializeBreadcrumb()
	}

	private initializeBreadcrumb(): void {
		let item1: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.parameters').toString(), link: "parameters-main" }
		let item2: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.google-review').toString() }
		breadcrumb.updateItems([item1, item2])
	}

	private computeGoogleReviewTextLength(): number {
		if (!this.configuration || !this.configuration.google_review.review_text) return GoogleReview.maxLength
		this.configuration.google_review.review_text = this.configuration.google_review.review_text.trim()

		let text: string = this.configuration.google_review.review_text

		let result: number = GoogleReview.maxLength - text.length

		this.googleReviewTextWarning = result < 0
		return result
	}

	public previewGoogleReviewLink(): void {
		const linkId = this.configuration.google_review.review_link_id;
		const url = `https://g.page/r/${linkId}/review`;
		window.open(url, "_blank");
	}

}
